export const DrawerSizes = {
  medium: '1300px',
}
